// extracted by mini-css-extract-plugin
module.exports = {"welcomeGallery":"style_welcomeGallery__uEzXF","welcomeGallerySlides":"style_welcomeGallerySlides__DcgzE","sliderGalleryStory":"style_sliderGalleryStory__6HR7S"};